export default "__VITE_ASSET__D5vmZ3Vz__"